import axiosInstance from 'utils/InstanceAxios/InstanceAxios';
import { Types } from '../reducers/drivers';
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import { toast } from 'react-toastify';

//Synchronous

//Asynchronous
export const getDrivers = (page, limit, query, sort = "") => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstance.get(serverRoutes.Drivers.crud('', { page, limit, query, sort }))
      .then((response) => {
        dispatch({
          type: Types.GET_DRIVERS,
          payload: response.data,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

export const getAllDrivers = () => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstance.get(serverRoutes.Drivers.getAll)
      .then((response) => {
        dispatch({
          type: Types.GET_DRIVERS,
          payload: response.data,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

export const getDriver = (driverName) => {
  return dispatch => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstance.get(serverRoutes.Drivers.crud(`/${driverName}`))
      .then(response => {
        dispatch({
          type: Types.GET_DRIVER,
          payload: response.data,
        })
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_DRIVER,
          payload: null,
        });
      });
  }
}

export const createDriver = (driver, callback) => {
  return dispatch => {
    axiosInstance.post(serverRoutes.Drivers.crud(), driver)
      .then(response => {
        dispatch({
          type: Types.CREATE_DRIVERS,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.CREATE_DRIVERS,
          payload: null,
        });
        callback(false)
      })
  }
}

export const updateDriver = (id, driver, callback) => {
  return (dispatch, getState) => {
    axiosInstance.put(serverRoutes.Drivers.crud(`/${id}`), {driver})
      .then(response => {
        dispatch({
          type: Types.UPDATE_DRIVERS,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        console.log(err);
        callback(false);
        const { drivers } = getState();
        dispatch({
          type: Types.UPDATE_DRIVERS,
          payload: drivers.driver,
        });
        toast.error(`Erro: ${err.response?.data?.error?.message || err.response?.data?.error || err.response?.data }`, { autoClose: 10000 });
      })
  }
}

export const deleteDriver = (id, callback) => {
  return dispatch => {
    axiosInstance.delete(serverRoutes.Drivers.crud(`/${id}`))
      .then(response => {
        dispatch({
          type: Types.DELETE_DRIVERS,
        });
        callback();
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.DELETE_DRIVERS,
        });
      })
  }
}

export const uploadDriverFile = (file, callback) => {
  return dispatch => {
      axiosInstance.post(serverRoutes.Drivers.crud('/uploadDriver'), file, {
          onUploadProgress: e => {
              const progress = parseInt(Math.round((e.loaded * 100) / e.total));
              callback({ progress });
          }
      })
      .then(response => {
          dispatch({
              type: Types.UPLOAD_DRIVER_FILE,
              payload: {content: response.data.uploadedDriverFile, connect: true},
          });

          callback({
              uploaded: true,
              id: response.data.uploadedDriverFile._id,
              // url: response.data.uploadedDriverFile.url,
              // path: response.data.path,
          });
      })
      .catch(err => {
          dispatch({
              type: Types.UPLOAD_DRIVER_FILE,
              payload: null,
          });
          callback({
              error: true,
              id: err.response?.data?._id,
          });
      });
  }
}

export const deleteDriverFile = (fileId, callback) => {
  return dispatch => {
      axiosInstance.delete(serverRoutes.Drivers.crud(`/uploadDriver/${fileId}`))
      .then(response => {
          dispatch({
              type: Types.DELETE_DRIVER_FILE,
          });
          callback();
      })
      .catch(err => {
          console.log(err);
          callback();
      });
  }
}
